import * as React from "react";
import { useXoraiaValue } from "../../../../hooks/useXoraia";
import { Grid } from "../../../core/Grid";

interface ProductDetailsPreviewGridProps {
  images: string[];
  name: string;
}

const ProductDetailsPreviewGrid: React.FC<ProductDetailsPreviewGridProps> = ({
  images,
  name,
}) => {
  const { env, imageComponent } = useXoraiaValue();

  const showImage = (index: number) => {
    const src = images[index];

    let img: any = (
      <img
        key={index.toString()}
        src={src}
        alt={name}
        loading="lazy"
        style={{ width: "100%", borderRadius: "10px" }}
      />
    );

    if (imageComponent) {
      img = imageComponent(
        {
          alt: name,
          src,
          width: "100%",
          borderRadius: {
            TopLeft: "10px",
            BottomLeft: "10px",
            BottomRight: "10px",
            TopRight: "10px",
          },
        },
        env ?? "dev",
        {},
        index.toString()
      );
    }

    return img;
  };

  return (
    <Grid columns={1} gap="15px" width="100%">
      {images.map((_, i) => (
        <div key={i.toString()}>{showImage(i)}</div>
      ))}
    </Grid>
  );
};

export default ProductDetailsPreviewGrid;
